import { createSlice } from "@reduxjs/toolkit";
import { GetDescriptionCode } from "../action";


interface DescriptionCode {
    _id: string;
    accountNumber: string;
    serviceDescription: string;
    serviceCode: string;
    unitMeasure: string;
    rateHistory: string;
    rateHistoryValue: Array<object>;
    unitRate: string;
    useService: string;
    revenueCode: string;
    rateCode: string;
    rateValue: string;
    locatorCode: string;
    useLocator: string;
    claimType: string;
    procedureModifier: string;
    primaryDiagnosis: string;
    diagnosisPointer: string;
    electronicUnit: string;
    procedureQualifier: string;
    addService: string;
    validationTotalBillable: string;
    unitOfMeasure: string;
    roundingAlgorithem: string;
    allowedIncreament: string
}

interface DescriptionCodeState {
    descriptionCode: DescriptionCode[] | any;
    isLoading: boolean
}

const initialState: DescriptionCodeState = {
    descriptionCode: [],
    isLoading: false
}


export const DescriptionCodeInitialState = createSlice({
    name: 'descriptionCode',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(GetDescriptionCode.fulfilled, (state, action: any) => {
            state.descriptionCode = action.payload.data
            state.isLoading = false
        })
            .addCase(GetDescriptionCode.pending, (state, action) => {
                state.isLoading = true
            })
            .addCase(GetDescriptionCode.rejected, (state, action) => {
                state.isLoading = false
            })
    }
})

export default DescriptionCodeInitialState.reducer